module.exports = __webpack_public_path__ + "img/Fondo1.e33a7961.jpg";